import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@app/material.module';

@Component({
  selector: 'app-custom-message',
  imports: [CommonModule, MaterialModule],
  templateUrl: './custom-message.component.html',
  styleUrl: './custom-message.component.scss'
})
export class CustomMessageComponent {

  constructor(
    public dialogRef: MatDialogRef<CustomMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data.duration) {
      setTimeout(()=>{ this.close(false); }, this.data.duration);
    }
  }

  close(response: boolean){
    this.dialogRef.close(response);
  }

}
